// extracted by mini-css-extract-plugin
export default {"container":"_3m5iqHPgLwEMPQthsPdDCw","title":"_1NvySxhid9tRh8OCBukFT3","buttons":"_-5hA_wzxnzVAgdoBaH95E"};